import { useState, useContext } from 'react';
import { useSearchParams } from 'react-router-dom';

import AppContext from '../../contexts/AppContext';
import DataContext from '../../contexts/DataContext';

export default function ButtonQuestion({
  className,
  dataKey,
  icon,
  iconHover,
  option,
  selected,
  showStackedIcons,
}: any) {
  const { currentPageIndex, setCurrentPageIndex, updateSelectedOption } =
    useContext(AppContext);
  const { data, updateData } = useContext(DataContext);
  const [hover, setHover] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const { name, nextPage, value } = option;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault(); // prevent full page reload

    let newData = { ...data };
    newData[dataKey] = value;
    updateData(newData);
    updateSelectedOption(dataKey, value);

    // set current page index
    setCurrentPageIndex(currentPageIndex + 1);

    // update page param and navigate to next page
    searchParams.set('page', nextPage);
    setSearchParams(searchParams);

    switch (dataKey) {
      case 'property':
        dataLayer.push({
          event: 'seform_property_you_own',
          event_action: 'What kind of property do you own?',
          event_label: value,
        });
        break;
      case 'sunlight':
        dataLayer.push({
          event: 'seform_sunlight_your_roof_get',
          event_action: 'How much sunlight does your roof get?',
          event_label: value,
        });
        break;
    }
  };

  return (
    <button
      type="button"
      className={`group flex ${
        showStackedIcons ? 'flex-row' : 'flex-row md:flex-col md:basis-1/4'
      } items-center grow ${className ?? ''}${
        showStackedIcons ? 'mb-4' : 'mb-4 md:mb-0'
      }`}
      onMouseEnter={() => setHover(true)}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={handleClick}
      data-zuko-id={`${(
        dataKey +
        '_' +
        name.split(' ').join('_')
      ).toLowerCase()}`}>
      <div
        className={`w-[64px] md:w-[90px] h-[64px] md:h-[90px] md:group-hover:bg-enph-orange rounded-full flex justify-center items-center transition-colors duration-150 ${
          selected ? 'bg-[#3c3c3c]' : 'bg-[#F4F3F0]'
        }`}>
        <img
          className="w-[32px] md:w-10 h-[32px] md:h-10 md:group-hover:stroke-white"
          src={hover || selected ? iconHover : icon}
          alt={name}
        />
      </div>
      <p
        className={`text-[17px] short:text-[14px] ${
          showStackedIcons ? 'ml-[20px] text-left' : 'ml-[18px] md:ml-0 md:mt-4'
        }`}>
        {name}
      </p>
    </button>
  );
}
